<template>
    <div>
		<tab name="2"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="9" :xl="4">
                    <el-input v-model="params.value" class="input-with-select" size="small">
                        <el-select v-model="params.type" slot="prepend" placeholder="请选择">
                            <el-option label="商品ID" :value="1"></el-option>
                            <el-option label="商品名称" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>                
				<el-col :xs="24" :sm="12" :md="7" :xl="4">
				    <el-select v-model="params.deliveryType" placeholder="请选择商品使用场景" size="small">
				        <el-option label="不限制发货方式" value=""></el-option>
				        <el-option label="仅看快递发货的" :value="1"></el-option>
				        <el-option label="仅看现场自取的" :value="2"></el-option>
						<el-option label="仅看快递发货+现场自取的" :value="3"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="5" :xl="4" class="page-filter-btns">
				    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
				    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>				
             </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/shop_good/createOrUpdate')" type="primary" icon="el-icon-plus" size="small" @click="$refs.goodsAdd.show()">添加推荐商品</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="goodsId" label="商品ID" width="100"></el-table-column>
                <el-table-column prop="name" label="商品名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title" @click="$refs.H5Preview.show('/pages/goods/detail/detail?id='+scope.row.goodsId)">
                            {{scope.row.name}}
                        </el-link>
                    </template>
                </el-table-column>
				<el-table-column prop="deliveryType" label="发货方式">
					<template slot-scope="scope">
						 <span v-if="scope.row.deliveryType==1" >快递发货</span>
						 <span v-else-if="scope.row.deliveryType==2">现场自取</span>
						 <span v-else-if="scope.row.deliveryType==3">快递发货+现场自取</span>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="添加时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">                        
                        <el-button
                            v-if="$utils.have('/shop_good/createOrUpdate')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.goodsId)"
                            >编辑</el-button
                        >                        
                        <el-button
                            v-if="$utils.have('/good/recommend/del')"
                            type="text"
                            size="small"
                            icon="el-icon-delete"
                            @click="del(scope.row.id)"
                            >删除</el-button
                        >                        
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <GoodsAdd ref="goodsAdd" @onUpdate="getDataList"></GoodsAdd>
		<H5Preview ref="H5Preview"></H5Preview>
    </div>
</template>

<script>
import GoodsAdd from './components/goods-add';
import Tab from './components/tab'
import H5Preview from '@/components/H5Preview';
const defaultParams = {
    pageNo: 1,
    value: '',
    type:2,    
	deliveryType:'',
	
}
export default {
    components:{Tab,GoodsAdd,H5Preview},
    data (){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                value: this.$route.query.value || '',
                type:parseInt(this.$route.query.type || 2),                
                deliveryType:this.$route.query.deliveryType ? parseInt(this.$route.query.deliveryType) : '',
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
			freightList:[]
        }
    },
    computed:{
       
    },
    mounted(){        
		
		this.getDataList();
    },
    methods:{
        //获取列表
        getDataList(){
            this.listLoading = true;
            this.$request({
                url: '/good/recommend/list',
                method: 'POST',
                data: this.params
            }).then(res => {
                const { state, msg, result } = res.data;
                if( state == 1 && result ){
                    this.data = result;
                    this.dataList = result.result || [];
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },
		
        //选择pageSize
        handleSizeChange( e ){
            this.params.pageNo = 1
            this.params.pageSize = e
            this.getDataList()
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize				
            }
            this.getDataList();
        },

        //添加
        add(){
            
        },
		edit(id){
		    this.$router.push({
		        path:`/goodsManage/goods/edit/${id}`,
		        query: {
		            redirect: this.$utils.objArgs(
		                this.$router.currentRoute.path,
		                this.params
		            ),
		        },
		    });
		},
        //下架
        del(id){
			const _msg = `<div>删除后，该商品将不会出现在推荐区域<p>确认删除该推荐商品？</p></div>`;
			
            this.$confirm(_msg, '提示', {                
				center: true,
				closeOnClickModal: false,
				dangerouslyUseHTMLString: true,
				confirmButtonText: "确认删除",
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/good/recommend/del',
                    method: 'POST',
                    params: {goodsId:id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        this.getDataList();
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
            }).catch(() => {})
        },
        
    }
}
</script>